import React from "react";
import { ClipLoader } from "react-spinners";

import { LOADING_ICON_COLOR, DEFAULT_LOADING_SIZE_RATIO } from "./constants";
import { getScreenWidthInPixels } from "../../utils/commonUtils";

interface LoadingProps {
    loadingIconSizeRatio?: number;
}

const MaskLoading: React.FC<LoadingProps> = ({ loadingIconSizeRatio = DEFAULT_LOADING_SIZE_RATIO }) => {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    position: "relative",
                    zIndex: 1001,
                }}
            >
                <ClipLoader size={loadingIconSizeRatio * getScreenWidthInPixels()} color={LOADING_ICON_COLOR} loading />
            </div>
        </div>
    );
};

export default MaskLoading;
